class BESSAppTogglePassword extends BESSAppComponent {

    constructor() {
        super('.app-toggle-password');
    }


    setupComponent(componentNode) {
        componentNode.bindClickEvent(this, function () {

            let input = componentNode.parent().find('input');
            if (input.length > 0) {
                input = input[0];
                if (input.type === "password") {
                    input.type = "text";
                    componentNode.find('.icon-show-password').showIf(false);
                    componentNode.find('.icon-hide-password').showIf(true);
                    $(input).attr('aria-checked', true);
                } else {
                    input.type = "password";
                    componentNode.find('.icon-hide-password').showIf(false);
                    componentNode.find('.icon-show-password').showIf(true);
                    $(input).attr('aria-checked', false);
                }
            }

        });
    }
}